module.exports = __webpack_public_path__ + "media/customizations/wellenpark/back-7cbe0dc36d9ab1fb5839a5aad822891b.jpg";